import { render } from "./ModifyPaymentPassword.vue?vue&type=template&id=a15cdf78&scoped=true"
import script from "./ModifyPaymentPassword.vue?vue&type=script&lang=js"
export * from "./ModifyPaymentPassword.vue?vue&type=script&lang=js"

import "./ModifyPaymentPassword.vue?vue&type=style&index=0&id=a15cdf78&lang=less&scoped=true"

import exportComponent from "/Users/sun/Desktop/code/antpay-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a15cdf78"]])

export default __exports__